import {
  FETCH_STAGES_OVERVIEW,
  FETCH_BATCH_STAGES,
  COMPLETE_STAGE,
  ADD_STAGE_NOTE,
  UPDATE_STAGE,
  SET_STAGE_FILTERS,
  SET_STAGE_SORT,
  CLEAR_STAGES,
} from './stageActions';

const initialState = {
  // Data
  stages: [],
  batchStages: {},

  // UI State
  filters: {
    stage_type: null,
    status: null,
    organization: '',
  },
  sort: {
    sortBy: 'start_date',
    order: 'asc',
  },

  // Loading states
  isLoading: false,
  isUpdating: false,
  error: null,
};

const stagesReducer = (state = initialState, action) => {
  switch (action.type) {
    // ==================== FETCH STAGES OVERVIEW ====================
    case FETCH_STAGES_OVERVIEW.REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case FETCH_STAGES_OVERVIEW.SUCCESS:
      return {
        ...state,
        isLoading: false,
        stages: action.payload,
        error: null,
      };

    case FETCH_STAGES_OVERVIEW.FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    // ==================== FETCH BATCH STAGES ====================
    case FETCH_BATCH_STAGES.REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case FETCH_BATCH_STAGES.SUCCESS:
      return {
        ...state,
        isLoading: false,
        batchStages: {
          ...state.batchStages,
          [action.payload.batchId]: action.payload.stages,
        },
        error: null,
      };

    case FETCH_BATCH_STAGES.FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    // ==================== COMPLETE STAGE ====================
    case COMPLETE_STAGE.REQUEST:
      return {
        ...state,
        isUpdating: true,
        error: null,
      };

    case COMPLETE_STAGE.SUCCESS:
      return {
        ...state,
        isUpdating: false,
        stages: state.stages.map((stage) =>
          stage.id === action.payload.id ? action.payload : stage
        ),
        error: null,
      };

    case COMPLETE_STAGE.FAILURE:
      return {
        ...state,
        isUpdating: false,
        error: action.payload,
      };

    // ==================== ADD STAGE NOTE ====================
    case ADD_STAGE_NOTE.REQUEST:
      return {
        ...state,
        isUpdating: true,
        error: null,
      };

    case ADD_STAGE_NOTE.SUCCESS:
      return {
        ...state,
        isUpdating: false,
        stages: state.stages.map((stage) =>
          stage.id === action.payload.id ? action.payload : stage
        ),
        error: null,
      };

    case ADD_STAGE_NOTE.FAILURE:
      return {
        ...state,
        isUpdating: false,
        error: action.payload,
      };

    // ==================== UPDATE STAGE ====================
    case UPDATE_STAGE.REQUEST:
      return {
        ...state,
        isUpdating: true,
        error: null,
      };

    case UPDATE_STAGE.SUCCESS:
      return {
        ...state,
        isUpdating: false,
        stages: state.stages.map((stage) =>
          stage.id === action.payload.id ? action.payload : stage
        ),
        error: null,
      };

    case UPDATE_STAGE.FAILURE:
      return {
        ...state,
        isUpdating: false,
        error: action.payload,
      };

    // ==================== UI STATE ====================
    case SET_STAGE_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload,
        },
      };

    case SET_STAGE_SORT:
      return {
        ...state,
        sort: {
          sortBy: action.payload.sortBy,
          order: action.payload.order,
        },
      };

    case CLEAR_STAGES:
      return initialState;

    default:
      return state;
  }
};

export default stagesReducer;
